import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';

import { IonicModule } from '@ionic/angular';

import { ManageNonUsfProductsPageRoutingModule } from './manage-non-usf-products-routing.module';

import { ManageNonUsfProductsPage } from './manage-non-usf-products.page';
import { AddNonUsfProductComponent } from './components/modals/add-non-usf-product/add-non-usf-product.component';
import { NonUsfProductCardComponent } from './components/cards/non-usf-product-card/non-usf-product-card.component';
import { NonUsfProductCardContainerComponent } from './components/non-usf-product-card-container/non-usf-product-card-container.component';
import { EffectsModule } from '@ngrx/effects';
import { ManageNonUSFProductsEffects } from './effects/manage-non-usf-products.effects';
import { NonUsfProductSortHeaderComponent } from './components/non-usf-product-sort-header/non-usf-product-sort-header.component';
import { PimSelectionModalComponent } from './components/modals/pim-selection-modal/pim-selection-modal.component';
import { ImportNonUsfProductModalComponent } from './components/modals/import-non-usf-product-modal/import-non-usf-product-modal.component';
import { NonUsfProductImportToastComponent } from './components/shared/non-usf-product-import-toast/non-usf-product-import-toast.component';
import { ImportNonUsfProductErrorsModalComponent } from './components/modals/import-non-usf-product-errors-modal/import-non-usf-product-errors-modal.component';
import { MppShareModule } from '../../../mpp/shared/mpp-shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ManageNonUsfProductsPageRoutingModule,
    SharedModule,
    EffectsModule.forFeature([ManageNonUSFProductsEffects]),
    MppShareModule,
  ],
  declarations: [
    ManageNonUsfProductsPage,
    AddNonUsfProductComponent,
    PimSelectionModalComponent,
    NonUsfProductCardComponent,
    NonUsfProductCardContainerComponent,
    NonUsfProductSortHeaderComponent,
    ImportNonUsfProductModalComponent,
    NonUsfProductImportToastComponent,
    ImportNonUsfProductErrorsModalComponent,
  ],
})
export class ManageNonUsfProductsPageModule {}
